import styled from '@emotion/styled'

export const Container = styled.span`
  align-items: center;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`
